/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type HpRespFeaturedModule_homepage$ref = any;
export type HpRespFeaturedModule_homepage = {
    readonly featuredModule: ({
        readonly primaryItem?: {
            readonly cta: string | null;
            readonly link: string | null;
            readonly imageUrl: string | null;
            readonly title: string | null;
        } | null;
        readonly items?: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly cta: string | null;
            readonly link: string | null;
            readonly imageUrl: string | null;
            readonly title: string | null;
        } | null> | null;
    } & ({
        readonly primaryItem: {
            readonly cta: string | null;
            readonly link: string | null;
            readonly imageUrl: string | null;
            readonly title: string | null;
        } | null;
        readonly items: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly cta: string | null;
            readonly link: string | null;
            readonly imageUrl: string | null;
            readonly title: string | null;
        } | null> | null;
    } | {
        /*This will never be '% other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    })) | null;
    readonly " $refType": HpRespFeaturedModule_homepage$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "cta",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "link",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "imageUrl",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "HpRespFeaturedModule_homepage",
        "type": "Homepage",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": "featuredModule",
                "name": "module",
                "storageKey": "module(type:\"featured\")",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "featured"
                    }
                ],
                "concreteType": null,
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "type": "FeaturedModule",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "primaryItem",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FeaturedItem",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    (v1 /*: any*/),
                                    (v2 /*: any*/),
                                    (v3 /*: any*/)
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "items",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FeaturedItem",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "cmsId",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    (v0 /*: any*/),
                                    (v1 /*: any*/),
                                    (v2 /*: any*/),
                                    (v3 /*: any*/)
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '901cec811acac5fe88e07df176ea61f5';
export default node;
